enum Mutations {
  SET = 'set',
  DELETE = 'delete',
  UPDATE = 'update',
}

export default Mutations;
